import { agreementTemplateInitialStatus as initialStatus } from './agreementTemplateInitialStatus';
import {
  agreementTemplateInitialItem as initialItem,
  agreementTemplateInitialItems as initialItems,
  agreementTemplateInitialParagraphValues as initialParagraphValues,
  agreementTemplateInitialValues as initialValues,
} from './agreementTemplateInitialValues';

export default {
  initialStatus,
  initialValues,
  initialParagraphValues,
  initialItem,
  initialItems,
};
